module.exports = __webpack_public_path__ + "static/media/Minus.ff6403d0.svg";